import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reservation-header',
  templateUrl: './reservation-header.component.html',
  styleUrls: ['./reservation-header.component.scss']
})
export class ReservationHeaderComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.translate.use(this.translate.getDefaultLang());
  }

  public changeLanguage(language: string){
    this.translate.use(language);
    this.translate.setDefaultLang(language);
  }

  checkLanguage(language: string): boolean {
    return language == this.translate.currentLang;
  }

}
